(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("countup", [], factory);
	else if(typeof exports === 'object')
		exports["countup"] = factory();
	else
		root["countup"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 